"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSupportedLanguagesAsSelectOptions = exports.getFetchSupportedLanguagesRequestStatus = exports.getSupportedLanguages = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var _reselect = require("reselect");

var _actions = require("./actions");

var getSupportedLanguages = function getSupportedLanguages(state) {
  return state.supportedLanguages;
};

exports.getSupportedLanguages = getSupportedLanguages;
var getFetchSupportedLanguagesRequestStatus = (0, _getRequestStatus.default)(_actions.SupportedLanguagesActionTypes.FETCH_SUPPORTED_LANGUAGES);
exports.getFetchSupportedLanguagesRequestStatus = getFetchSupportedLanguagesRequestStatus;
var getSupportedLanguagesAsSelectOptions = (0, _reselect.createSelector)([getSupportedLanguages], function (languages) {
  return languages.reduce(function (acc, language, langKey) {
    return [].concat((0, _toConsumableArray2.default)(acc), [{
      text: language,
      value: langKey
    }]);
  }, []);
});
exports.getSupportedLanguagesAsSelectOptions = getSupportedLanguagesAsSelectOptions;